"use client";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { ResetReflectionsRequest } from "@/generated/fastapi";
import { useAuth } from "@/state/globalStore";
import { resetReflections } from "../api/resetReflections";
import { thoughtKeys } from "../queries/keys";

export default function useResetReflectionsMutation() {
  const queryClient = useQueryClient();
  const { accessToken } = useAuth();

  return useMutation({
    mutationFn: (request: ResetReflectionsRequest) =>
      resetReflections(accessToken, request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: thoughtKeys.all });
    },
  });
}
